import { render, staticRenderFns } from "./partitionManagementList.vue?vue&type=template&id=321bf03c&scoped=true&"
import script from "./partitionManagementList.vue?vue&type=script&lang=js&"
export * from "./partitionManagementList.vue?vue&type=script&lang=js&"
import style0 from "./partitionManagementList.vue?vue&type=style&index=0&id=321bf03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321bf03c",
  null
  
)

component.options.__file = "partitionManagementList.vue"
export default component.exports